import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-light-bg border-t border-sandy-beige/30 py-6 sm:py-8">
      <div className="container-custom px-4 sm:px-6">
        <div className="flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-3 sm:mb-4"
          >
            <Link
              to="/"
              className="text-xl sm:text-2xl font-heading font-bold text-muted-gold inline-block py-2 px-3 -mx-3 rounded-md hover:bg-sandy-beige/10 transition-colors"
              aria-label="LUCIEN14 Home"
            >
              LUCIEN14
            </Link>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-sm text-text-dark text-center px-4"
          >
            Designed in the LUCIEN14
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-xs text-gray-600 mt-2 text-center px-4"
          >
            &copy; {currentYear} LUCIEN14. All rights reserved.
          </motion.p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
